module.exports = require('./helpers/bundle-url').getBundleURL('gA8FI') + "testimonial-wonchul.e435ed72.webp";